import { useDataValue, useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'referrals',
    viewPath: props.viewPath,
  })

  let submitPersons = useDataSubmit({
    context: 'persons',
    viewPath: props.viewPath,
  })

  let referral_index = useDataValue({
    context: 'referral_item',
    viewPath: props.viewPath,
    path: 'index',
  })

  let person = useDataValue({
    context: 'person',
    viewPath: props.viewPath,
  })

  return async function onClick() {
    await submit({
      type: 'update_person',
      index: referral_index,
      person,
      is_patient: 'patient' in person,
    })

    submitPersons()
  }
}
